// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'garnett', 'garnett Fallback'"},"className":"__className_431389","variable":"__variable_431389"};